<template>
    <div class="bg-surface-background border-border-border-0 border-2 rounded-3xl overflow-hidden">
        <slot />
    </div>
</template>
